import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "rounded-xl border border-primary-200 bg-white p-4"
};
const _hoisted_2 = {
  class: "flex items-center justify-between"
};
const _hoisted_3 = {
  class: "text-sm font-semibold text-slate-800"
};
const _hoisted_4 = {
  key: 0,
  class: "ml-1 text-xs text-slate-400"
};
const _hoisted_5 = {
  key: 0,
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_6 = {
  class: "mt-3 max-h-96 overflow-y-auto rounded-lg bg-slate-50 p-3"
};
const _hoisted_7 = {
  key: 1,
  class: "mt-3 rounded-lg border border-amber-200 bg-amber-50 p-3"
};
const _hoisted_8 = {
  class: "text-xs font-medium text-amber-800"
};
const _hoisted_9 = {
  class: "mt-2 flex items-center gap-2"
};
const _hoisted_10 = {
  class: "mt-2"
};
const _hoisted_11 = {
  class: "mt-4 flex justify-end gap-2"
};
const _hoisted_12 = ["disabled"];
const _hoisted_13 = ["disabled"];
const _hoisted_14 = ["disabled"];
const _hoisted_15 = ["disabled"];
import { computed, reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';
import PlanSections from '../PlanSections.vue';
import { buildPlanReviewResume, EDITABLE_PLAN_FIELDS } from '../../composables/agentProtocol';
export default {
  __name: 'PlanReviewCard',
  props: {
    snapshot: {
      type: Object,
      required: true
    },
    pending: {
      type: Boolean,
      default: false
    }
  },
  emits: ['resume'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const plan = computed(() => (props.snapshot.interrupt_payload || {}).plan || {});
    const evaluation = computed(() => plan.value.evaluation || {});
    const editableHint = computed(() => EDITABLE_PLAN_FIELDS.join('/'));

    // 审核轮次：按方案内容指纹本地计数（同方案重挂载不重复计数；重启后从 1 计起——宁缺勿错）
    const roundText = ref('');
    if (typeof window !== 'undefined') {
      const p = plan.value;
      const fingerprint = `${(p.warnings || []).length}:${p.quotation_total}:${(p.gaps || []).length}`;
      const key = `plan-review-round:${props.snapshot.task_id}`;
      const state = JSON.parse(sessionStorage.getItem(key) || '{"n":0,"fp":""}');
      if (state.fp !== fingerprint) {
        state.n += 1;
        state.fp = fingerprint;
        sessionStorage.setItem(key, JSON.stringify(state));
      }
      roundText.value = state.n > 0 ? `（第 ${state.n}/5 轮）` : '';
    }
    const conclusionText = computed(() => {
      if (evaluation.value.passed === true) return '判定通过';
      if (evaluation.value.passed === false) return '判定不通过';
      return '待人工复核';
    });
    const conclusionClass = computed(() => {
      if (evaluation.value.passed === true) return 'bg-emerald-50 text-emerald-700';
      if (evaluation.value.passed === false) return 'bg-red-50 text-red-700';
      return 'bg-amber-50 text-amber-700';
    });
    const editing = ref(false);
    const editForm = reactive({
      quotation_total: null
    });
    const editNote = ref('');
    function startEdit() {
      editForm.quotation_total = plan.value.quotation_total;
      editing.value = true;
    }
    function submitEdit() {
      const edits = {};
      if (editForm.quotation_total != null && editForm.quotation_total !== plan.value.quotation_total) {
        edits.quotation_total = editForm.quotation_total;
      }
      if (editNote.value.trim()) {
        edits.timeline = [...(plan.value.timeline || [])];
        if (edits.timeline.length) {
          edits.timeline[0] = {
            ...edits.timeline[0],
            items: [...(edits.timeline[0].items || []), editNote.value.trim()]
          };
        }
      }
      if (Object.keys(edits).length === 0) {
        ElMessage.warning('没有修改内容');
        return;
      }
      editing.value = false;
      emit('resume', buildPlanReviewResume('edit', edits).payload);
    }
    function handleApprove() {
      emit('resume', buildPlanReviewResume('approve').payload);
    }
    function handleSuspend() {
      emit('resume', buildPlanReviewResume('suspend').payload);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, [_cache[2] || (_cache[2] = _createTextVNode("方案审核", -1)), roundText.value ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(roundText.value), 1)) : _createCommentVNode("", true)]), _createElementVNode("span", {
        class: _normalizeClass(["status-badge", conclusionClass.value])
      }, _toDisplayString(conclusionText.value), 3)]), plan.value.evaluation?.score != null ? (_openBlock(), _createElementBlock("p", _hoisted_5, "评分：" + _toDisplayString(plan.value.evaluation.score), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createVNode(PlanSections, {
        plan: plan.value
      }, null, 8, ["plan"])]), editing.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("p", _hoisted_8, "编辑修正（仅白名单字段：" + _toDisplayString(editableHint.value) + "）", 1), _createElementVNode("div", _hoisted_9, [_cache[3] || (_cache[3] = _createElementVNode("label", {
        class: "text-sm text-slate-600"
      }, "报价合计（元）", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => editForm.quotation_total = $event),
        type: "number",
        class: "form-input form-control-sm w-36"
      }, null, 512), [[_vModelText, editForm.quotation_total, void 0, {
        number: true
      }]])]), _createElementVNode("div", _hoisted_10, [_cache[4] || (_cache[4] = _createElementVNode("label", {
        class: "text-sm text-slate-600"
      }, "时间线备注（追加到 T0 阶段）", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => editNote.value = $event),
        class: "form-input form-control-sm w-full",
        placeholder: "如：客户要求 10 月前完成申报"
      }, null, 512), [[_vModelText, editNote.value]])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_createElementVNode("button", {
        class: "btn-secondary form-control-sm",
        disabled: __props.pending,
        onClick: handleSuspend
      }, "挂起", 8, _hoisted_12), !editing.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "btn-outline-primary form-control-sm",
        disabled: __props.pending,
        onClick: startEdit
      }, "编辑修正", 8, _hoisted_13)) : (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: "btn-outline-primary form-control-sm",
        disabled: __props.pending,
        onClick: submitEdit
      }, "提交修正", 8, _hoisted_14)), _createElementVNode("button", {
        class: "btn-primary form-control-sm",
        disabled: __props.pending,
        onClick: handleApprove
      }, _toDisplayString(__props.pending ? '处理中…' : '批准定稿'), 9, _hoisted_15)])]);
    };
  }
};